import { getInvalidConflicts } from '../../../../components/optional-ec-conflicts/conflicts-helpers';
import { isInactiveOptionType } from '../helpers/ec-helpers';

export { getInvalidConflictByEC } from '../../../../components/optional-ec-conflicts/conflicts-helpers';

const getConflictEcList = (optionalECs) => {
  const ecList = [];
  optionalECs.forEach((cat) => {
    ecList.push(
      ...cat.data
        .filter(({ inputOptionType }) => !isInactiveOptionType(inputOptionType))
        .map(({ id, equipmentCode: ec, includes, excludes, requires }) => ({
          id,
          ec,
          includes: includes.newValue,
          excludes: excludes.newValue,
          requires: requires.newValue,
        })),
    );
  });
  return ecList;
};

// validate original conflicts
export const getInvalidConflictECs = (optECs) => {
  const conflictECs = getConflictEcList(optECs);
  return getInvalidConflicts(conflictECs);
};

// re-validate conflicts with updated field value
export const validateConflicts = (EC, field, value, optionalECs) => {
  const conflictECs = getConflictEcList(optionalECs);
  const ecIndex = conflictECs.findIndex(({ ec }) => ec === EC);
  conflictECs.splice(ecIndex, 1, {
    ...conflictECs[ecIndex],
    [field]: value,
  });
  return getInvalidConflicts(conflictECs);
};
